export default function Interests()
{
    return (
                <div className=" flex justify-center items-center  h-full">
                            <ul className="list-disc  tracking-wide">
                                    <li >
                                    <span className="font-bold">Drawing</span>
                                        <p>Sketching is an outlet for creativity, allowing me to transform my thoughts into visual representations.</p>
                                    </li>
                                <br/>
                                    <li >
                                    <span className="font-bold">Listening to Songs</span>
                                        <p >We can experience all emotions through songs, which makes it easier to comprehend others' emotional states when collaborating.</p>
                                    </li>
                                <br/>
                            </ul>
                </div>
    );
}